import { AnnotationBase, AnnotationPlugin } from '@st/document-viewer-kit'
import { CaretToolState } from '~/st-doc-viewer/annotations'

const INITIAL_TOOL_STATE: CaretToolState = {
  name: 'caret',
  settings: {}
}

export function caretToolPlugin(): AnnotationPlugin<AnnotationBase, CaretToolState> {
  return {
    name: 'caret',
    initialToolState: INITIAL_TOOL_STATE
  }
}
